import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import isMobile from "./isMobile.js";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import Vant from "vant";
import "vant/lib/index.css";
import axios from "axios";
import { baseUrl } from "./constants/config";

import { ElLoading } from "element-plus";
let loadingInstance = "";
router.beforeEach((to, form, next) => {
  loadingInstance = ElLoading.service({ fullscreen: true });

  // 判断是PC端还是Mobile端
  var urlroute = window.location.pathname.toLowerCase().split("/");
  if (store.state.cname !== urlroute[1]) {
    store.commit("setCname", urlroute[1]);
  }
  var path = to.path;
  if (isMobile()) {
    if (path === "/") {
      next({ path: "/mobile" });
    } else if (path.indexOf("/pc") !== -1) {
      path = path.replace("pc", "mobile");
      next({ path: path });
    } else {
      next();
    }
  } else {
    if (path === "/") {
      next({ path: "/pc" });
    } else if (path.indexOf("/mobile") !== -1) {
      path = path.replace("mobile", "pc");
      next({ path: path });
    } else {
      next();
    }
  }
});

router.afterEach(() => {
  setTimeout(() => {
    loadingInstance.close();
  }, 1000);
});

const app = createApp(App).use(store).use(router).use(ElementPlus).use(Vant);

// 配置 axios
axios.defaults.baseURL = baseUrl;
axios.defaults.timeout = 30000;

// 全局提供 axios
app.provide("$axios", axios);
app.provide("$get", (url, params) => axios.get(url, { params }));
app.provide("$post", (url, data) => axios.post(url, data));

app.mount("#app");
